window.OBCustomDocumentsModal = function ($scope, Upload) {
    var self = this;

    self.OBIdObj = null;
    self.availableDocs = [];
    self.loading = true;
    self.saving = false;
    var MODAL_SELECTOR = "#ob_custom_docs_modal";
    var RED_ALERT = "red_alert";

    var events = {
        "documents_updated": []
    };

    self.onDocumentsUpdated = function (handler) {
        events["documents_updated"].push(handler);
    };

    self.isThereAnyUploadedDocuments = false;

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    self.show = function (OBIdObj) {

        $scope.obCustomDocumentsForm = new OBCustomDocumentsForm($scope);

        self.OBIdObj = OBIdObj;
        $scope.obCustomDocumentsForm.isOtherDocuments = self.OBIdObj.isOtherDocuments;
        OnBoardingAPI.listDocuments(self.OBIdObj.application_id, self.OBIdObj.prospect_id, 'CANDIDATE_CUSTOM', null, true)
            .then(function (docs) {
                    self.availableDocs = docs;
                    self.loading = false;
                    var hasMinor = false;
                    self.availableDocs = self.availableDocs.filter(function (doc) {

                        if (!doc.code.startsWith('MINOR_WORK_DOCUMENTATION')) {
                            hasMinor = true;

                            return doc;
                        }
                    });
                    if (hasMinor) {
                        self.availableDocs.push(
                            {
                                code: "CUSTOM_MINOR_DOCUMENTS",
                                name: "Minor Work Documentation",
                                signature_mode: "SINGLE",
                                type: "DOCUMENT",
                            });
                    }
                    $scope.obCustomDocumentsForm.availableDocs = self.availableDocs;

                    $scope.$digest();
                },
                function (err) {
                    self.hide();
                });

        self.isThereAnyUploadedDocuments = self.OBIdObj.otherDocuments && self.OBIdObj.otherDocuments.length && !_.isEmpty(self.OBIdObj.otherDocuments);

        $(MODAL_SELECTOR).modal("show");
        $(MODAL_SELECTOR).on('hidden.bs.modal', function () {
            self.destroy();
            $('#' + RED_ALERT).modal('hide');
        });
        $scope.obCustomDocumentsForm.addNewDocument();

    };

    self.hide = function () {
        if (self.uploading) {
            hAlert('Warning', 'Still uploading...', undefined, '', undefined, undefined, RED_ALERT);
        } else {
            self.uploading = false;
            $(MODAL_SELECTOR).modal('hide');
            $('#' + RED_ALERT).modal('hide');
            self.destroy();
        }
    };

    self.destroy = function () {
        self.OBIdObj = null;
        self.docs = [];
        delete $scope.obCustomDocumentsForm;
        self.loading = true;
        self.uploading = false;
        $scope.$digest();
    };


    //Upload Documents
    var uploadDocument = function (doc) {
        var defer = $q.defer();
        //mark as uploading
        doc.isUploading = true;
        var data = {
            prospect_id: self.OBIdObj.prospect_id,
            application_id: self.OBIdObj.application_id,
            document_lookup_code: doc.code,
            viewable_by_candidate: doc.viewableByCandidate,
            custom_name: doc.name,
            meta_data: {
                product_name: doc.product_name,
                lot_number: doc.lot_number || '',
                vaccination_status: doc.vaccination_status,
                booster_date: '',
                vaccination_date: ''
            },
        }
        if (doc.has_expiration_date) {
            data.has_expiration_date = doc.has_expiration_date;
        }
        if (doc.type_name) {
            data.document_lookup_code = doc.type_name;
        }
        if (doc.expiration_date) {
            data.expiration_date = Utils.getISODate(doc.expiration_date.startOf('day'));
        }
        if (doc.vaccination_date) {
            data.meta_data.vaccination_date = doc.vaccination_date.format('YYYY-MM-DD');
        }
        if (doc.booster_date) {
            data.meta_data.booster_date = doc.booster_date.format('YYYY-MM-DD');
        }
        data['meta_data'] = JSON.stringify(data.meta_data);
        //upload
        Upload.upload({
            url: publicConfiguration.OnboardingServerBaseURL + 'document_upload',
            withCredentials: true,
            headers: {},
            method: "PUT",
            data: data,
            file: doc.selectedFile
        }).progress(function (evt) {
            var uploaded = evt.loaded || 0;
            var total = evt.total;
            doc.uploadProgress = 100 * uploaded / total;
        }).success(function (data, status, headers, config) {
            //mark uploading finished
            doc.isUploading = false;
            doc.uploadProgress = 0;
            //defer of resolve
            if (data.status_code == 200) {
                //mark it as saved
                doc.saved = true;
                //resolve
                defer.resolve(doc);
            } else {
                //upload error
                doc.uploadingError = data.data;
                doc.isUploading = false;
                //reject doc
                defer.reject(doc);
            }
        }).error(function (reason) {
            //upload error
            doc.uploadingError = reason.data;
            //done uploading
            doc.isUploading = false;
            //log error
            console.error(reason);
            //reject doc
            defer.reject(doc);
        });
        return defer.promise;
    };

    //Upload selected documents
    self.uploadDocuments = function () {
        if ($scope.obCustomDocumentsForm && $scope.obCustomDocumentsForm.validator.validate()) {
            self.uploading = true;
            $scope.obCustomDocumentsForm.uploading = self.uploading;
            //Queue all promises in an array
            var promisses = [];
            if ($scope.obCustomDocumentsForm.newDocs) {

                for (var i in $scope.obCustomDocumentsForm.newDocs) {

                    if ($scope.obCustomDocumentsForm.newDocs[i].selectedFile && !$scope.obCustomDocumentsForm.newDocs[i].saved) {
                        promisses.push(uploadDocument($scope.obCustomDocumentsForm.newDocs[i]));
                    }

                }

                //Resolve all uploadings
                $q.all(promisses).then(function (resolutions) {
                    //Documents Updated
                    trigger('documents_updated', self.OBIdObj);
                    self.uploading = false;
                    $scope.obCustomDocumentsForm.uploading = self.uploading;
                    //hide the modal
                    self.hide();
                }, function (errors) {
                    self.uploading = false;
                    $scope.obCustomDocumentsForm.uploading = self.uploading;
                    //alert error
                    hAlert('Error uploading file', 'Failed to upload some files', undefined, '', undefined, undefined, RED_ALERT);
                    console.error(errors);
                });
            }
        }
    }

    //Delete Document
    self.deleteDocument = function (doc) {
        hConfirm({
            title: $filter("translate")("Delete Confirmation"),
            text: $filter("translate")("Are you sure you want to delete this document?"),
            confirmButton: $filter("translate")("Yes"),
            cancelButton: $filter("translate")("Cancel"),
            callback: function (confirmed) {
                if (confirmed) {
                    doc.deleteInProgress = true;
                    OnBoardingAPI.deleteDocument(doc.id).then(function (res) {
                        self.OBIdObj.otherDocuments = _.filter(self.OBIdObj.otherDocuments, function (other_doc) {
                            return other_doc.id != doc.id;
                        });
                        trigger('documents_updated', self.OBIdObj);
                        self.isThereAnyUploadedDocuments = self.OBIdObj.otherDocuments && self.OBIdObj.otherDocuments.length && !_.isEmpty(self.OBIdObj.otherDocuments);
                        //sync scope
                        $scope.$digest();
                    }, function (err) {
                        console.error(err);
                    });
                }
            }
        });
    }


}
